import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import React, { useState } from 'react'
import ModalHeader from '../../common/Header'
import '../../../styles/Reports/SearchPNR.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getSearchPNR } from '../../../redux/Report/ReportActions'
import { updateShowAlert } from '../../../redux/Actions'
import SearchPNRDetails from './SearchPNRDetails'
import CustomRadio from '../../common/CustomRadio'
import SearchIcon from '@mui/icons-material/Search';

const SearchPNR = () => {
    const { userDetails } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const [selectRadio, setSelectRadio] = useState(1)
    const [showReport, setShowReport] = useState(false)
    const [reportData, setReportData] = useState([])
    const [searchQuery, setSearchQuery] = useState()

    const groupAndMergeData = (table, table1) => {
        if (!table || !table1) return [];
        const groupedData = table1.reduce((acc, item) => {
            const { BookingID, Fare, ServiceTax, PickupCharge, DropoffCharge } = item;
            if (!acc[BookingID]) {
                acc[BookingID] = {
                    BookingID,
                    allSeatFare: 0,
                    allSeatServiceTax: 0,
                    allSeatPickupCharge: 0,
                    allSeatDropoffCharge: 0,
                };
            }
            acc[BookingID].allSeatFare += Fare || 0;
            acc[BookingID].allSeatServiceTax += ServiceTax || 0;
            acc[BookingID].allSeatPickupCharge += PickupCharge || 0;
            acc[BookingID].allSeatDropoffCharge += DropoffCharge || 0;

            return acc;
        }, {});

        return table.map(booking => {
            const bookingData = groupedData[booking.BookingID] || {};
            return { ...booking, ...bookingData };
        });
    };
    const handleGenerate = () => {
        //validation
        if (!searchQuery) {
            dispatch(updateShowAlert({
                msg: 'Search query cannot be empty!',
                open: true,
            }));
            return;
        }
        if (selectRadio === 2 && !/^\d{10}$/.test(searchQuery)) {
            dispatch(updateShowAlert({
                msg: 'Mobile No should be a valid 10-digit number!',
                open: true,
            }));
            return;
          }
          
        setShowReport(false)
        const body = {
            intUserID: userDetails?.UserID,
            strSearchType: selectRadio === 1 ? 'P' : selectRadio === 2 ? 'M' : 'S',
            intBookingID: selectRadio === 1 ? searchQuery : 0,
            strSeatNo: selectRadio === 3 ? searchQuery : '',
            intTripID: 0,
            dtJDate: '01-Jan-0001',
            intFromCityId: 0,
            intToCityID: 0,
            intAgentUserID: 0,
            strContactNo: selectRadio === 2 ? searchQuery : '',
        }
        dispatch(getSearchPNR(body)).then((res) => {
            let data = res?.data.APIBookingsLoadResult
            if (res.status === 200) {
                const parsedData = JSON.parse(data);
                if (parsedData?.Table && parsedData?.Table1) {
                    const result = groupAndMergeData(parsedData.Table, parsedData.Table1);
                    setReportData(result || []);
                    setShowReport(true)
                }

            } else {
                dispatch(updateShowAlert({
                    msg: data?.ErrorMessage,
                    open: true,
                }));
            }
        })
    }
    const radioList = [
        { label: "PNR", value: 1 },
        { label: "Mobile", value: 2 },
        { label: "Seats", value: 3 },
    ];
    return (
        <Box className="searchPNRpage" sx={{ height: '100vh', overflowY: 'auto' }}>
            {/* Sticky Header Section */}
            <Box sx={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
                <ModalHeader headerText={"Search Booking"} showHamburger={true} />
                <Box className='filter-section'>
                    <CustomRadio
                        name="journeyDate"
                        value={selectRadio}
                        onChange={(e) => { setSelectRadio(Number(e.target.value)); setShowReport(false); setSearchQuery('') }}
                        radioList={radioList}
                        direction={'row'}
                    />
                </Box>
                <Box className='search-box' sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Enter Search Query"
                        value={searchQuery}
                        onChange={(e) => { setSearchQuery(e.target.value); setShowReport(false) }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleGenerate}>
                                        <SearchIcon sx={{ color: '#0086ff' }} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                            '& .MuiInputBase-input': {
                                caretColor: '#ff7100 ', // Change the cursor color
                                //fontSize: '20px'
                            },
                            backgroundColor: '#f7f7f7' // Optional, to ensure no background color
                        }}
                    />
                </Box>
            </Box>

            {/* Scrollable Content */}
            {showReport && (
                <SearchPNRDetails
                    reportData={(reportData?.length > 0 ? reportData : [])}
                    handleBack={() => {
                        setShowReport(false);
                        setReportData([]);
                    }}
                />
            )}
        </Box>
    )
}

export default SearchPNR